// extracted by mini-css-extract-plugin
export default {"appleButton":"apple-login-button_appleButton__N3Oje","createUser":"apple-login-button_createUser__uYLog"};